<template>
  <div v-if="text">
    <div v-for="(v,idx) in values" :key="idx">{{v}}</div>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
export default {
  name: 'SquareWords',
  props: {text: String},
  computed: {
    values(vm) {
      return (vm.text || '').split('|');
    }
  },
};
</script>

<style scoped>

</style>